import React from 'react';
import '../styles/Button.css';

type ButtonVariant = 'solid' | 'outline';
type ButtonSurface = 'light' | 'dark';
type ButtonSize = 'xs' | 'sm' | 'md' | 'lg' | 'xl';
type ButtonType = 'button' | 'submit' | 'reset';

interface ButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  type?: ButtonType;
  disabled?: boolean;
  variant?: ButtonVariant;
  surface?: ButtonSurface;
  size?: ButtonSize;
  className?: string;
  'data-testid'?: string;
}

/**
 * Button Component - Arc Design System
 */
function Button({
  children,
  onClick,
  type = 'button',
  disabled = false,
  variant = 'solid',
  surface = 'light',
  size = 'md',
  className = '',
  'data-testid': testId,
}: ButtonProps) {
  const buttonClass = `arc-button arc-button-${variant} arc-button-${surface} arc-button-${size} ${className}`;

  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={buttonClass}
      data-testid={testId}
    >
      {children}
    </button>
  );
}

export default Button;
